import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'urlToLink'
})
export class UrlToLinkPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string): string {
    if (!text) return text;
    
    // URL regex pattern - matches both HTTP and HTTPS URLs with valid TLD
    const urlRegex = /(https?:\/\/[a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;
    
    // Check if the regex matches any URLs in the text
    if (!urlRegex.test(text)) {
      return text; // Return original text if no URLs found
    }
    
    // Reset regex index since test() advances it
    urlRegex.lastIndex = 0;
    
    // Replace URLs with clickable links
    const linkedText = text.replace(urlRegex, (url) => {
      const isSecure = url.startsWith('https://');
      const warningClass = isSecure ? '' : 'insecure-link';
      const warningIcon = isSecure ? '' : '⚠️ ';
      const warningTitle = isSecure ? '' : ' title="Insecure HTTP link - proceed with caution"';
      
      return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="chat-link ${warningClass}"${warningTitle}>${warningIcon}${url}</a>`;
    });
    
    return linkedText;
  }
}
